import { ResourceTerm } from '@shared/api/graphql/generated';

/** Формы слова ресурса записи: «симулятор», «симулятора», «симуляторы», «симуляторов». */
export interface ResourceTermForms {
  one: string;
  oneGenitive: string;
  many: string;
  manyGenitive: string;
}

const FORMS: Record<ResourceTerm, ResourceTermForms> = {
  [ResourceTerm.Simulator]: {
    one: 'симулятор',
    oneGenitive: 'симулятора',
    many: 'симуляторы',
    manyGenitive: 'симуляторов',
  },
  [ResourceTerm.Chair]: { one: 'кресло', oneGenitive: 'кресла', many: 'кресла', manyGenitive: 'кресел' },
  [ResourceTerm.Post]: { one: 'пост', oneGenitive: 'поста', many: 'посты', manyGenitive: 'постов' },
  [ResourceTerm.Cabinet]: { one: 'кабинет', oneGenitive: 'кабинета', many: 'кабинеты', manyGenitive: 'кабинетов' },
  [ResourceTerm.Place]: { one: 'место', oneGenitive: 'места', many: 'места', manyGenitive: 'мест' },
};

/** Термин без настройки организации — нейтральное «место». */
export const resourceTermForms = (term: ResourceTerm | null | undefined): ResourceTermForms =>
  FORMS[term ?? ResourceTerm.Place];

/** Подпись варианта в настройке компании: «Симулятор». */
export const resourceTermTitle = (term: ResourceTerm): string => capitalize(FORMS[term].one);

/** «Симуляторы» для заголовков. */
export const capitalize = (word: string): string => word.charAt(0).toLocaleUpperCase('ru-RU') + word.slice(1);

/** Варианты селекта в порядке показа. */
export const RESOURCE_TERM_OPTIONS: ReadonlyArray<{ id: ResourceTerm; title: string }> = [
  ResourceTerm.Simulator,
  ResourceTerm.Chair,
  ResourceTerm.Post,
  ResourceTerm.Cabinet,
  ResourceTerm.Place,
].map((id) => ({ id, title: resourceTermTitle(id) }));
